import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { adminSessionQueryOptions, meQueryOptions } from '@/lib/query-options'
import { AdminSidebar } from '@/routes/-components/admin-sidebar/admin-sidebar'

export const Route = createFileRoute('/(private)')({
	ssr: false,
	beforeLoad: async ({ context, location }) => {
		const session = await context.queryClient.fetchQuery(
			adminSessionQueryOptions()
		)

		// A pending challenge means credentials already passed: resume the
		// second factor instead of asking for them again.
		if (session.sessionType === 'mfa_pending') {
			throw redirect({
				to: '/two-factor',
				search: { redirect: location.href }
			})
		}
		if (session.sessionType !== 'authenticated') {
			throw redirect({
				to: '/login',
				search: { redirect: location.href }
			})
		}
	},
	loader: ({ context }) =>
		context.queryClient.ensureQueryData(meQueryOptions()),
	component: () => (
		<AdminSidebar>
			<Outlet />
		</AdminSidebar>
	)
})
